import React from 'react';


const tecno = [
   
    { T: 'MySql', L: 'https://www.mysql.com/' },
   

];

class Gameoverbi extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">





                    <div className="sectionProyect">


                        <div className="titleSectionProyect">
                            <h1>GameOverWeb data base</h1>

                        </div>
                        <svg> <rect></rect> </svg>

                        <div className="imageProyect imageGameOverweb"></div>
                        <div className="listT" >

                            {tecno.map(tec => (
                                <div key={tec}>
                                    <a href={tec.L} target="_blank" rel="noreferrer">

                                        <button className="animateButtonTech">  <p> <span>&#183;</span> {tec.T}</p></button>
                                    </a>
                                </div>

                            ))}
                        </div>

                        <p>This MySql database belongs to the gameoverweb application made with the help of the Django ORM.</p>
                        <a href="https://github.com/BrandonGrimaldoM/GameOverWebDataBase" target="_blank" rel="noreferrer">
                            <button className="animateButtonGit"> <p>Repository </p> <div className="gitIcon"></div> </button>
                        </a>
                    </div>




                </div>


            </React.Fragment>
        );
    }
}

export default Gameoverbi;